import {
  CAR_VALUES,
  PURPOSE_SOURCE_VALUES,
  PERIOD_SOURCE,
  EMPLOYMENT_VALUES as EMPLOYMENT_TYPE_VALUES,
  UNEMPLOYMENT_REASONS as UNEMPLOYMENT_REASON_VALUES,
  INCOME_CONFIRMATION_SOURCE as INCOME_CONFIRMATION_VALUES,
  SENIORITY_PERIODS as SENIORITY_VALUES,
  JOB_TYPE_SOURCE as JOB_TYPE_VALUES,
  AREA_OF_EMPLOYMENT_SOURCE as AREA_OF_EMPLOYMENT_VALUES,
  EMPLOYER_TYPE_SOURCES as EMPLOYER_TYPE_VALUES,
  EDUCATION_SOURCE as EDUCATION_VALUES,
  FAMILY_STATUS_SOURCE as MARITAL_STATUS_VALUES,
  NUMBER_OF_DEPENDENTS_SOURCE as NUMBER_OF_DEPENDENTS_VALUES,
  ADDITIONAL_PHONE_OWNER_VALUES,
  PROPERTY_TYPE_SOURCE as PROPERTY_TYPE_VALUES,
  GENDER_SOURCE,
} from '@sravni/creditselection-customer-utils/lib/utils/customers';

export const GENDERS = {
  MALE: GENDER_SOURCE.MALE,
  FEMALE: GENDER_SOURCE.FEMALE,
  UNKNOWN: GENDER_SOURCE.UNKNOWN,
} as const;

export const CREDIT_PURPOSES = [
  {
    name: 'Кредит наличными',
    value: PURPOSE_SOURCE_VALUES.MONEY,
  },
  {
    name: 'Рефинансирование кредита',
    value: PURPOSE_SOURCE_VALUES.REFINANCE_CREDIT,
  },
  {
    name: 'Покупка нового автомобиля',
    value: PURPOSE_SOURCE_VALUES.NEW_CAR,
  },
  {
    name: 'Покупка подержанного автомобиля',
    value: PURPOSE_SOURCE_VALUES.USED_CAR,
  },
] as const;

export const PERIODS = [
  { name: '6 месяцев', value: PERIOD_SOURCE.P6M },
  { name: '1 год', value: PERIOD_SOURCE.P1Y },
  { name: '2 года', value: PERIOD_SOURCE.P2Y },
  { name: '3 года', value: PERIOD_SOURCE.P3Y },
  { name: '4 года', value: PERIOD_SOURCE.P4Y },
  { name: '5 лет', value: PERIOD_SOURCE.P5Y },
  { name: '7 лет', value: PERIOD_SOURCE.P7Y },
  { name: '10 лет', value: PERIOD_SOURCE.P10Y },
  { name: '15 лет', value: PERIOD_SOURCE.P15Y },
] as const;

export const EMPLOYMENT_TYPES = [
  {
    name: 'Работа по найму',
    value: EMPLOYMENT_TYPE_VALUES.EMPLOYMENT,
  },
  {
    name: 'Собственный бизнес',
    value: EMPLOYMENT_TYPE_VALUES.BUSINESS_OWNER,
  },
  {
    name: 'Судья',
    value: EMPLOYMENT_TYPE_VALUES.JUDGE,
  },
  {
    name: 'Военнослужащий',
    value: EMPLOYMENT_TYPE_VALUES.SERVICEMAN,
  },
  {
    name: 'Госслужащий',
    value: EMPLOYMENT_TYPE_VALUES.STATE_EMPLOYEE,
  },
  {
    name: 'Пенсионер',
    value: EMPLOYMENT_TYPE_VALUES.RETIRED,
  },
  {
    name: 'Не работаю',
    value: EMPLOYMENT_TYPE_VALUES.NOT_WORKING_VALUE,
  },
] as const;

export const UNEMPLOYMENT_REASONS = [
  { name: 'Судья в отставке', value: UNEMPLOYMENT_REASON_VALUES.RETIRED_JUDGE },
  { name: 'Ищу работу', value: UNEMPLOYMENT_REASON_VALUES.SEARCH_JOB },
  { name: 'Содержит муж/жена', value: UNEMPLOYMENT_REASON_VALUES.SPOUSE },
  { name: 'Другое', value: UNEMPLOYMENT_REASON_VALUES.OTHER },
] as const;

export const INCOME_CONFIRMATIONS = [
  { name: 'Справка 2-НДФЛ', value: INCOME_CONFIRMATION_VALUES.NDFL2 },
  { name: 'Справка 3-НДФЛ', value: INCOME_CONFIRMATION_VALUES.NDFL3 },
  { name: 'Справка по форме банка', value: INCOME_CONFIRMATION_VALUES.BANK_FORM },
  { name: 'Без подтверждения дохода', value: INCOME_CONFIRMATION_VALUES.NONE },
] as const;

export const SENIORITY = [
  { name: 'Меньше 1 года', value: SENIORITY_VALUES.P6M.value },
  { name: 'От 1 года до 3 лет', value: SENIORITY_VALUES.P1Y.value },
  { name: 'От 3 до 10 лет', value: SENIORITY_VALUES.P3Y.value },
  { name: 'Более 10 лет', value: SENIORITY_VALUES.P10Y.value },
] as const;

export const JOB_TYPES = [
  {
    name: 'Руководитель организации',
    value: JOB_TYPE_VALUES.HEAD_OF_ORGANIZATION,
  },
  {
    name: 'Руководитель подразделения',
    value: JOB_TYPE_VALUES.HEAD_OF_DEPARTMENT,
  },
  {
    name: 'Неруководящий сотрудник - специалист',
    value: JOB_TYPE_VALUES.SPECIALIST,
  },
  {
    name: 'Неруководящий сотрудник - обсл. персонал',
    value: JOB_TYPE_VALUES.SERVICE_STAFF,
  },
] as const;

export const AREAS_OF_EMPLOYMENT = [
  { name: 'Горнодобывающая промышленность', value: AREA_OF_EMPLOYMENT_VALUES.MINING_INDUSTRY, meta: '05-09' },
  {
    name: 'Государственное, муниципальное управление',
    value: AREA_OF_EMPLOYMENT_VALUES.STATE_MUNICIPAL_ADMINISTRATION,
    meta: '84-84.21,84.25-84.4',
  },
  { name: 'Образование', value: AREA_OF_EMPLOYMENT_VALUES.EDUCATION, meta: '85' },
  {
    name: 'Здравоохранение, социальные услуги',
    value: AREA_OF_EMPLOYMENT_VALUES.HEALTH_CARE_SOCIAL_SERVICES,
    meta: '86-88',
  },
  {
    name: 'Культура, искусство, спортивная деятельность',
    value: AREA_OF_EMPLOYMENT_VALUES.CULTURE_SPORTS_ACTIVITIES,
    meta: '90-93',
  },
  {
    name: 'Оборона, правоохранительные органы',
    value: AREA_OF_EMPLOYMENT_VALUES.DEFENSE_LAW_ENFORCEMENT_AGENCIES,
    meta: '84.23-84.24',
  },
  {
    name: 'Обрабатывающая промышленность (производство)',
    value: AREA_OF_EMPLOYMENT_VALUES.MANUFACTURING_INDUSTRY,
    meta: '10-34',
  },
  {
    name: 'Профессиональная, научная, техническая деятельность',
    value: AREA_OF_EMPLOYMENT_VALUES.PROFESSIONAL_SCIENTIFIC_TECHNICAL_ACTIVITIES,
    meta: '69-75',
  },
  {
    name: 'Сельское хозяйство, рыболовство, охота, лесоводство',
    value: AREA_OF_EMPLOYMENT_VALUES.AGRICULTURE_FISHING_HUNTING_FORESTRY,
    meta: '01-04',
  },
  { name: 'Строительство', value: AREA_OF_EMPLOYMENT_VALUES.BUILDING, meta: '41-43' },
  {
    name: 'Сфера торговли, услуг, связи',
    value: AREA_OF_EMPLOYMENT_VALUES.TRADE_SERVICES_COMMUNICATIONS,
    meta: '45-47,55-63,77-82,95-98',
  },
  { name: 'Транспорт', value: AREA_OF_EMPLOYMENT_VALUES.TRANSPORT, meta: '49-53' },
  { name: 'Финансовая деятельность, страхование', value: AREA_OF_EMPLOYMENT_VALUES.FINANCE_INSURANCE, meta: '64-68' },
  {
    name: 'Электроэнергия, газо-, водо-, теплоснабжение',
    value: AREA_OF_EMPLOYMENT_VALUES.ELECTRICITY_GAS_WATER_HEAT_SUPPLY,
    meta: '35-39',
  },
  { name: 'Иное (в крайнем случае)', value: AREA_OF_EMPLOYMENT_VALUES.OTHER },
] as const;

export const EMPLOYER_TYPES = [
  { name: 'ООО', value: EMPLOYER_TYPE_VALUES.OOO, meta: '12300' },
  { name: 'ИП', value: EMPLOYER_TYPE_VALUES.IP, meta: '50102' },
  { name: 'АО', value: EMPLOYER_TYPE_VALUES.AO, meta: '12200' },
  { name: 'ПАО', value: EMPLOYER_TYPE_VALUES.PAO, meta: '12247' },
  { name: 'НАО', value: EMPLOYER_TYPE_VALUES.NAO, meta: '12267' },
  { name: 'Государственное бюджетное учреждение', value: EMPLOYER_TYPE_VALUES.STATE_INSTITUTION, meta: '75203' },
  {
    name: 'Федеральное государственное казенное учреждение',
    value: EMPLOYER_TYPE_VALUES.FEDERAL_STATE_TREASURY,
    meta: '75104',
  },
  { name: 'Муниципальное бюджетное учреждение', value: EMPLOYER_TYPE_VALUES.MUNICIPAL_INSTITUTION, meta: '75403' },
  { name: 'Филиал', value: EMPLOYER_TYPE_VALUES.BRANCH, meta: '30002' },
  { name: 'Я не знаю', value: EMPLOYER_TYPE_VALUES.DONT_KNOW, meta: '0' },
] as const;

export const EDUCATION = [
  { name: 'Начальное, среднее', value: EDUCATION_VALUES.PRIMARY },
  { name: 'Среднее специальное', value: EDUCATION_VALUES.SECONDARY_SPECIAL },
  { name: 'Неполное высшее', value: EDUCATION_VALUES.INCOMPLETE_HIGHER },
  { name: 'Высшее', value: EDUCATION_VALUES.HIGHER },
  { name: 'Второе высшее', value: EDUCATION_VALUES.SECOND_HIGHER },
  { name: 'Ученая степень', value: EDUCATION_VALUES.ACADEMIC_DEGREE },
] as const;

export const MARITAL_STATUS = [
  { name: 'Холост/не замужем', value: MARITAL_STATUS_VALUES.SINGLE },
  { name: 'Разведен(а)', value: MARITAL_STATUS_VALUES.DIVORCED },
  { name: 'Гражданский брак', value: MARITAL_STATUS_VALUES.CIVIL_MARRIAGE },
  { name: 'Женат/замужем', value: MARITAL_STATUS_VALUES.MARRIED },
  { name: 'Вдовец/вдова', value: MARITAL_STATUS_VALUES.WIDOW },
] as const;

export const NUMBER_OF_DEPENDENTS = [
  { name: 'Нет', value: NUMBER_OF_DEPENDENTS_VALUES.NONE },
  { name: '1', value: NUMBER_OF_DEPENDENTS_VALUES.ONE },
  { name: '2', value: NUMBER_OF_DEPENDENTS_VALUES.TWO },
  { name: '3', value: NUMBER_OF_DEPENDENTS_VALUES.THREE },
  { name: 'Больше 3', value: NUMBER_OF_DEPENDENTS_VALUES.MORE_THAN_THREE },
] as const;

export const ADDITIONAL_PHONE_OWNER = [
  { name: 'Мой номер', value: ADDITIONAL_PHONE_OWNER_VALUES.MY_NUMBER },
  { name: 'Номер родственника', value: ADDITIONAL_PHONE_OWNER_VALUES.RELATIVE_NUMBER },
  { name: 'Номер друга', value: ADDITIONAL_PHONE_OWNER_VALUES.FRIEND_NUMBER },
] as const;

export const CAR_AVAILABILITY = [
  { name: 'Нет', value: CAR_VALUES.NO },
  { name: 'Отечественный', value: CAR_VALUES.DOMESTIC },
  { name: 'Иномарка', value: CAR_VALUES.FOREIGN },
] as const;

export const PROPERTY_TYPE_AVAILABILITY = [
  { name: 'Квартира', value: PROPERTY_TYPE_VALUES.FLAT },
  { name: 'Апартаменты', value: PROPERTY_TYPE_VALUES.APARTMENTS },
  { name: 'Коммерческая недвижимость', value: PROPERTY_TYPE_VALUES.COMMERCIAL_REAL_ESTATE },
  { name: 'Нет', value: PROPERTY_TYPE_VALUES.NOTHING },
] as const;

const PLEDGE_ESTATE_OWNER_RELATIONSHIP_VALUES = {
  SPOUSE: 'Spouse',
  PARENT: 'Parent',
  CHILD: 'Child',
  ANOTHER_RELATIVE: 'AnotherRelative',
  OTHER: 'Other',
} as const;

export const PLEDGE_ESTATE_OWNER_RELATIONSHIP = [
  { name: 'Супруг/супруга', value: PLEDGE_ESTATE_OWNER_RELATIONSHIP_VALUES.SPOUSE },
  { name: 'Родитель', value: PLEDGE_ESTATE_OWNER_RELATIONSHIP_VALUES.PARENT },
  { name: 'Ребёнок', value: PLEDGE_ESTATE_OWNER_RELATIONSHIP_VALUES.CHILD },
  { name: 'Другой родственник', value: PLEDGE_ESTATE_OWNER_RELATIONSHIP_VALUES.ANOTHER_RELATIVE },
  { name: 'Другое', value: PLEDGE_ESTATE_OWNER_RELATIONSHIP_VALUES.OTHER },
] as const;

export const CREDIT_SECURITY_TYPES_VALUES = {
  NO_MATTER: 'NoMatter',
  WITHOUT_BAIL: 'WithoutBail',
  SECURED_BY_AVAILABLE_REAL_ESTATE: 'SecuredByAvailableRealEstate',
  SECURED_BY_AVAILABLE_VEHICLE: 'SecuredByAvailableVehicle',
} as const;

export const CREDIT_SECURITY_TYPES = [
  {
    value: CREDIT_SECURITY_TYPES_VALUES.NO_MATTER,
    name: 'Не важно',
  },
  {
    value: CREDIT_SECURITY_TYPES_VALUES.WITHOUT_BAIL,
    name: 'Без залога',
  },
  {
    value: CREDIT_SECURITY_TYPES_VALUES.SECURED_BY_AVAILABLE_REAL_ESTATE,
    name: 'Под залог недвижимости',
  },
  {
    value: CREDIT_SECURITY_TYPES_VALUES.SECURED_BY_AVAILABLE_VEHICLE,
    name: 'Под залог автомобиля',
  },
] as const;

export const PRODUCT_TYPES_VALUES = {
  CREDIT: 'Credit',
  CREDIT_CARD: 'CreditCard',
  MICRO_CREDIT: 'MicroCredit',
} as const;

export const PRODUCT_TYPES = [
  {
    value: PRODUCT_TYPES_VALUES.CREDIT,
    name: 'Кредит',
  },
  {
    value: PRODUCT_TYPES_VALUES.CREDIT_CARD,
    name: 'Кредитная карта',
  },
  {
    value: PRODUCT_TYPES_VALUES.MICRO_CREDIT,
    name: 'МФО',
  },
] as const;

export const AnyDictionaryItemValue = 'AnyItem';

export const ANY_AUTO_BRAND_DICTIONARY_SELECT_OPTION = {
  value: AnyDictionaryItemValue,
  label: 'Любая',
  data: { id: AnyDictionaryItemValue, alias: AnyDictionaryItemValue, name: 'Любая' },
};

export const ANY_AUTO_BRAND_INCOMING_ITEM = {
  id: AnyDictionaryItemValue,
  alias: AnyDictionaryItemValue,
  name: 'Любая',
};

export const ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION = {
  value: AnyDictionaryItemValue,
  label: 'Любая',
  data: { id: AnyDictionaryItemValue, alias: AnyDictionaryItemValue, name: 'Любая' },
};

export const ANY_AUTO_MODEL_INCOMING_ITEM = {
  id: AnyDictionaryItemValue,
  alias: AnyDictionaryItemValue,
  name: 'Любая',
};

export type TGender = ValuesOf<typeof GENDERS>;
export type TCreditPurpose = (typeof CREDIT_PURPOSES)[number]['value'];
export type TPeriod = (typeof PERIODS)[number]['value'];
export type TEmploymentType = (typeof EMPLOYMENT_TYPES)[number]['value'];
export type TUnemploymentReason = (typeof UNEMPLOYMENT_REASONS)[number]['value'];
export type TIncomeConfirmation = (typeof INCOME_CONFIRMATIONS)[number]['value'];
export type TSeniority = (typeof SENIORITY)[number]['value'];
export type TJobType = (typeof JOB_TYPES)[number]['value'];
export type TAreaOfEmployment = (typeof AREAS_OF_EMPLOYMENT)[number]['value'];
export type TEmployerType = (typeof EMPLOYER_TYPES)[number]['value'];
export type TEducation = (typeof EDUCATION)[number]['value'];
export type TMaritalStatus = (typeof MARITAL_STATUS)[number]['value'];
export type TNumberOfDependents = (typeof NUMBER_OF_DEPENDENTS)[number]['value'];
export type TAdditionalPhoneOwner = (typeof ADDITIONAL_PHONE_OWNER)[number]['value'];
export type TCarAvailability = (typeof CAR_AVAILABILITY)[number]['value'];
export type TPropertyTypeAvailability = (typeof PROPERTY_TYPE_AVAILABILITY)[number]['value'];
export type TPledgeEstateOwnerRelationship = (typeof PLEDGE_ESTATE_OWNER_RELATIONSHIP)[number]['value'];
export type TCreditSecurityType = (typeof CREDIT_SECURITY_TYPES)[number]['value'];
export type TProductType = (typeof PRODUCT_TYPES)[number]['value'];
